import { showFiveSections } from './showFiveSections.js';


// run before any other document.ready code executes
showFiveSections();
